var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "component-radio",
      class: _vm.computedClass,
      on: { click: _vm.handleClickRadio }
    },
    [
      _c("div", { staticClass: "component-radio-render" }),
      _c("div", {
        staticClass: "component-label-render w-normal",
        domProps: { innerHTML: _vm._s(_vm.label) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }